import React from 'react';
import TablaDoc from './TablaDoc';

/**
 * Sirve para las dos listas de negocios: recuperables urgentes y ya contratados.
 * Lo único que cambia es la etiqueta de la tercera columna y si hay fecha límite,
 * por eso llegan por prop.
 */
const TablaCasos = ({
  casos = [],
  etiquetaSenal,
  mostrarLimite = false,
  t,
}) => {
  const columnas = [
    {
      label: t('ap_colConsultantDeal'),
      ancho: '19%',
      render: (fila) => (
        <>
          <strong>{fila.consultor}</strong>
          <span className='ap-doc-sec'>
            {t('ap_deal')} {fila.deal_id}
          </span>
        </>
      ),
    },
    {
      label: t('ap_colClientService'),
      ancho: '20%',
      render: (fila) => (
        <>
          <strong>{fila.cliente}</strong>
          <span className='ap-doc-sec'>{fila.servicio}</span>
          {fila.telefono && (
            <span className='ap-doc-sec'>{fila.telefono}</span>
          )}
        </>
      ),
    },
    {
      label: etiquetaSenal,
      ancho: '29%',
      render: (fila) => (
        <>
          {mostrarLimite && fila.fecha_limite && (
            <strong className='ap-doc-limite'>
              {t('ap_limitDate')}: {fila.fecha_limite}
            </strong>
          )}
          <span className='ap-doc-parrafo'>{fila.senal_urgencia}</span>
        </>
      ),
    },
    {
      label: t('ap_colAction'),
      ancho: '32%',
      render: (fila) => fila.accion_hoy,
    },
  ];

  return (
    <TablaDoc columnas={columnas} filas={casos} textoVacio={t('ap_noRows')} />
  );
};

export default TablaCasos;
